// src/redux/reducers/companySizeReducer.js

import {
    FETCH_COMPANY_SIZE_REQUEST,
    FETCH_COMPANY_SIZE_SUCCESS,
    FETCH_COMPANY_SIZE_FAILURE,
    SET_SELECTED_COMPANY_SIZE,
} from '../types';

const initialState = {
    loading: false,
    companySizes: [],
    selectedCompanySizeId: null,
    error: '',
};

const companySizeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COMPANY_SIZE_REQUEST:
            return { ...state, loading: true };
        case FETCH_COMPANY_SIZE_SUCCESS:
            return { ...state, loading: false, companySizes: action.payload, error: '' };
        case FETCH_COMPANY_SIZE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_SELECTED_COMPANY_SIZE:
            return { ...state, selectedCompanySizeId: action.payload };
        default:
            return state;
    }
};

export default companySizeReducer;
